import './app.scss';

import './app.scss';
import domready from 'domready';
import 'lazysizes';
import {checkAndLoadFiles, createElementFromHTML, getOffset, smoothScrollTo} from './utilities/js/helper';
import { loadLazyImages } from './utilities/js/lazy-image-loader';
import { EventScroller } from './utilities/js/event-scroller';
import { MediaMatchHandler } from './utilities/js/media-match-handler';
import { ResizeHandler } from './utilities/js/resize-handler';
import SiteHeader from './layout/siteheader/siteheader';
import Navigation from './layout/navigation/navigation';

// GLOBAL OPTIONS
const OPTIONS = { // eslint-disable-line
    breakpoints: {
        s: 320,
        m: 768,
        l: 1024,
        xl: 1280,
        xxl: 1440,
        xxxl: 1920
    }
};

window.eventScroller = new EventScroller();
window.mediaMatchHandler = new MediaMatchHandler();
window.resizeHandler = new ResizeHandler();

window.youtubeApi = false;
window.youtubeApiLoading = false;
window.locale = document.querySelector('html').getAttribute('lang');
window.siteheaderAPI = null;

// GLOBAL OPTIONS
window.OPTIONS = { // eslint-disable-line
    loader: '<div class="loading" data-loader="root"><span class="loader"></span></div>',
};

const browserCheck = () => {
    window.browser = {
        csshover: !window.matchMedia('(pointer:coarse)').matches,
        ios: (/iPhone|iPad|iPod/i).test(navigator.userAgent),
        iphone: (/iPhone|iPod/i).test(navigator.userAgent),
        android: (/(android)/i).test(navigator.userAgent),
        firefox: (/firefox/i).test(navigator.userAgent),
        safari: (/Version\/[\d.]+.*Safari/).test(navigator.userAgent)
    };

    Object.entries(window.browser).forEach(([key, value]) => {
        document.documentElement.classList.add((!value) ? `no-${key}` : `${key}`);
    });
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');
};

window.checkInView = (entries, observer) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            if (!entry.target.classList.contains('inview')) {
                entry.target.classList.add('inview');

                if (typeof entry.target.dataset.footer === 'undefined') {
                    window.inViewObserver.unobserve(entry.target);
                }
            }
        }
    });
};

window.inViewObserver = new IntersectionObserver(window.checkInView, {
    threshold: 0.1
});

const backToLastURLBtns = ($content) => {
    const $$backToBtns = $content.querySelectorAll('[data-go-back-to-last-url="root"]');
    if ($$backToBtns.length > 0) {
        $$backToBtns.forEach($backToBtn => {
            $backToBtn.onclick = () => {
                window.history.back();
            };
        });
    }
};

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    backToLastURLBtns($context);
});

const updateBookmarkLinkAndAmount = () => {
    const bookmarkedJobs = JSON.parse(localStorage.getItem('bookmarkedJobs')) || [];
    const $$jobBookmarkLinks = document.querySelectorAll('[data-job-bookmark="link"]');
    const bookedIds = [];

    if (bookmarkedJobs.length > 0) {
        bookmarkedJobs.forEach((job) => {
            bookedIds.push(job.id);
        });
    }

    const bookedParam = bookedIds.join(',');

    if ($$jobBookmarkLinks.length > 0) {
        $$jobBookmarkLinks.forEach($jobBookmarkLink => {
            const $jobBookmarkAmount = $jobBookmarkLink.querySelector('[data-job-bookmark="amount"]');
            const newBookmarkUrl = `${$jobBookmarkLink.dataset.jobBookmarkUrl}?booked=${bookedParam}`;
            $jobBookmarkLink.setAttribute('href', newBookmarkUrl);

            if ($jobBookmarkAmount) {
                $jobBookmarkAmount.innerText = bookedIds.length;
            }
        });
    }
};

// go through all stored jobs in localStorage and check if they "active"
const cleanupBookmarks = () => {
    const bookmarkedJobs = JSON.parse(localStorage.getItem('bookmarkedJobs')) || [];

    if (bookmarkedJobs.length > 0) {
        bookmarkedJobs.forEach((job, i) => {
            if (bookmarkedJobs.length === (i + 1)) {
                checkIfJobIsActive(job.id, bookmarkedJobs, true);
            } else {
                checkIfJobIsActive(job.id, bookmarkedJobs);
            }
        });
    }
};

// check if job is active - if not remove from localStorage - if all jobs are done update bookmark link and amount
const checkIfJobIsActive = (jobId, bookmarkedJobs, testFinish = false) => {
    const htmlTag = document.documentElement;
    const langAttribute = htmlTag.getAttribute('lang');

    fetch(
        `https://${window.location.hostname}/${langAttribute}/check_job?id=${jobId}`
    )
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            if (data.response === 'failed') {
                const updatedJobs = bookmarkedJobs.filter(job => job.id !== jobId); // remove job by id from array
                localStorage.setItem('bookmarkedJobs', JSON.stringify(updatedJobs));
            }

            if (testFinish === true) {
                updateBookmarkLinkAndAmount();
            }
        })
        .catch(error => {
            console.error("Error while checking job:", error);
        });
};

window.addEventListener('update.bookmarks', (e) => {
    if (e.detail) {
        updateBookmarkLinkAndAmount();
    }
});

const initContent = ($content) => {
    console.log('start app');

    const $$anchor = $content.querySelectorAll('a[href*="#"]:not([data-anchor-navigation])');
    for (let i = 0; i < $$anchor.length; i++) {
        const $anchor = $$anchor[i];
        let anchorTimeout = null;

        $anchor.addEventListener('click', (e) => {
            let baseUrl = $anchor.getAttribute('href').split('#')[0];
            const targetId = $anchor.getAttribute('href').split('#')[1];
            const $target = document.getElementById(targetId);
            const currentUrl = window.location.href;
            let focusTimer = null;

            if (baseUrl === '') {
                baseUrl = currentUrl;
            }

            if (baseUrl === currentUrl && $target !== null) {
                const anchorDimensions = getOffset($target);
                const anchorDimensionsTop = anchorDimensions.top;

                smoothScrollTo(0, anchorDimensionsTop, window.OPTIONS.speed);

                $target.setAttribute('tabindex', 0);
                $target.focus();

                focusTimer = setTimeout(() => {
                    $target.removeAttribute('tabindex');
                    clearTimeout(focusTimer);
                }, 200);

                if (window.location.hash && window.siteheaderAPI) {
                    clearTimeout(anchorTimeout);
                    anchorTimeout = window.setTimeout(() => {
                        window.siteheaderAPI.toggleHeader(false);
                    }, 500);
                }
                e.preventDefault();
            }
        });

        if (window.location.hash && window.siteheaderAPI) {
            clearTimeout(anchorTimeout);
            anchorTimeout = window.setTimeout(() => {
                window.siteheaderAPI.toggleHeader(false);
            }, 500);
        }
    }

    loadLazyImages();
};

domready(function () {
    const initApplication = () => {
        browserCheck();

        window.eventScroller.init();
        window.resizeHandler.init();

        window.dataInview = document.querySelectorAll('[data-inview]:not(.inview)');
        setTimeout(() => {
            window.dataInview.forEach((dataInView) => {
                window.inViewObserver.observe(dataInView);
            });
        }, 500);

        const $siteheader = document.querySelector('[data-siteheader="root"]');
        if ($siteheader) {
            const siteheaderAPI = new SiteHeader($siteheader);
            $siteheader.API = siteheaderAPI;
        }

        const $navigation = document.querySelector('[data-nav="root"]');
        if ($navigation) {
            const navigationAPI = new Navigation($navigation);
            $navigation.API = navigationAPI;
        }

        const contentUpdateEvent = new CustomEvent('content.loaded', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: document
            }
        });

        window.dispatchEvent(contentUpdateEvent);

        document.body.classList.add('page--loaded');
        window.addEventListener('beforeunload', () => {
            const isMailTo = document.activeElement.protocol === 'mailto:';
            const isTel = document.activeElement.protocol === 'tel:';

            if (!(isMailTo && isTel)) {
                document.body.classList.remove('page--loaded');
            }
        });

        window.addEventListener('pageshow', (event) => {
            const historyTraversal = event.persisted || (typeof window.performance !== 'undefined' && window.performance.navigation.type === 2);
            if (historyTraversal) {
                window.location.reload();
            }
        });

        // jump to main content and set focus on container
        document.querySelector('.hidden-shortcut a[href="#main"]').addEventListener('click', () => {
            document.querySelector('#main').focus();
        });

        initContent(document);
        cleanupBookmarks();
    };

    initApplication();
});